<template>
  <div class="c-layered-map">
    <div class="c-layered-map__map"></div>
    <slot name="features"></slot>
  </div>
</template>
<script>
function loadedGoogleMapsAPI(apiKey) {
  return new Promise((resolve, reject) => {
    const googleMap = document.createElement("script");
    window.googleMapsInit = resolve;
    googleMap.setAttribute(
      "src",
      `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=googleMapsInit`
    );
    document.body.appendChild(googleMap);
  });
}

export default {
  name: "MapLoader",
  props: ["apiKey", "isDesktop"],
  data() {
    return {
      map: null,
    };
  },
  mounted() {
    loadedGoogleMapsAPI(this.apiKey).then(this.createMap);
  },
  methods: {
    getZoomLevel() {
      if (this.isDesktop) {
        return 9;
      }
      return 8;
    },
    createMap() {
      this.map = new google.maps.Map(
        document.querySelector(".c-layered-map__map"),
        {
          center: { lat: 51.139934, lng: -2.684195 },
          zoom: this.getZoomLevel(),
          disableDefaultUI: true,
        }
      );

      const styledMapType = new google.maps.StyledMapType([
        {
          featureType: "poi",
          elementType: "all",
          stylers: [{ color: "#dfd2ae" }, { visibility: "off" }],
        },
      ]);
      this.map.mapTypes.set("styled_map", styledMapType);
      this.map.setMapTypeId("styled_map");
      this.$emit("mapCreated", this.map);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapLoader.vue